/**
 * FIN-7470 (C3DS-RD-19): chaves de contexto de produto que o `/success` precisa
 * para remontar o `productFlow` e que se perdem na navegação full-page do
 * REDIRECT (Rede) — o provider descarta a query no retorno (ASS-09).
 *
 * Extrai só o essencial do funil da oferta (`oferta` + `source`/`seller`), nunca
 * a query inteira nem PII: viaja no `THREE_DS_CONTEXT` (sessionStorage) e é
 * re-injetado na query no retorno, jamais na URL enviada ao provider.
 */
export type ReturnQueryLike = Record<string, string | string[] | undefined>;

const PRODUCT_CONTEXT_KEYS = ['oferta', 'source', 'seller'] as const;

export const buildThreeDsReturnQuery = (
  query?: ReturnQueryLike
): Record<string, string> => {
  const result: Record<string, string> = {};

  if (!query) {
    return result;
  }

  PRODUCT_CONTEXT_KEYS.forEach((key) => {
    const value = query[key];
    const resolved = Array.isArray(value) ? value[0] : value;

    if (resolved) {
      result[key] = String(resolved);
    }
  });

  return result;
};
